export const environment = {
  production: true,
  serverUrl: 'https://api-soporte.bytefactory.es/api/v1',
  environment: 'dev',
  defaultLanguage: 'es-ES',
  supportedLanguages: ['es-ES', 'en-US'] as const,
};
